import React from "react";
import {createArrayFromEnum} from "../util/arrayUtils";

const LicenceStatus = {
    ACTIVE: 1,
    EXPIRED: 2,
    REVOKED: 3,
    DELETED: 4
};

const LicenceStatusText = {
    1: 'ACTIVE',
    2: 'EXPIRED',
    3: 'REVOKED',
    4: 'DELETED'
};

const LicenceStatusColor = {
    1: 'success',
    2: 'default',
    3: 'warning',
    4: 'error',
};

const licenceStatusArray = createArrayFromEnum(LicenceStatus);

export { LicenceStatus, LicenceStatusText, LicenceStatusColor, licenceStatusArray };